module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/indusindbanktransactions/edit-indusind-bank-transaction/edit-indusind-bank-transaction.component.css
// module id = ./src/app/indusindbanktransactions/edit-indusind-bank-transaction/edit-indusind-bank-transaction.component.css
// module chunks = main